// ui/src/theme.js

export const pageStyle = {
  maxWidth: 960,
  margin: "0 auto",
  padding: 24,
};

export const colors = {
  bg: "#e5e7eb",
  card: "#ffffff",
  accent: "#2563eb",
  accentSoft: "#dbeafe",
  textMain: "#0f172a",
  textSoft: "#64748b",
  borderSoft: "#d1d5db",
  danger: "#dc2626",
  dangerSoft: "#fee2e2",
};

export const typography = {
  pageTitle: 40,
  sectionTitle: 30,
  cardTitle: 28,
  bodyLarge: 24,
  body: 22,
  small: 18,
};

export const shadows = {
  card: "0 8px 24px rgba(15, 23, 42, 0.12)",
  button: "0 10px 22px rgba(37, 99, 235, 0.45)",
};

export const radius = {
  card: 20,
  button: 16,
  pill: 999,
};

export const buttons = {
  primary: {
    fontSize: 24,
    padding: "16px 24px",
    borderRadius: radius.button,
    border: "none",
    background: colors.accent,
    color: "#ffffff",
    boxShadow: shadows.button,
    cursor: "pointer",
  },
  secondary: {
    fontSize: 22,
    padding: "14px 22px",
    borderRadius: radius.button,
    border: `1px solid ${colors.borderSoft}`,
    background: "#f9fafb",
    color: colors.textMain,
    cursor: "pointer",
  },
  subtle: {
    fontSize: 22,
    padding: "10px 20px",
    borderRadius: radius.pill,
    border: `1px solid ${colors.borderSoft}`,
    background: "#f9fafb",
    color: colors.textMain,
    cursor: "pointer",
  },
  danger: {
    fontSize: 22,
    padding: "14px 22px",
    borderRadius: radius.button,
    border: "none",
    background: colors.danger,
    color: "#ffffff",
    cursor: "pointer",
  },
  dangerSoft: {
    fontSize: 22,
    padding: "12px 20px",
    borderRadius: radius.button,
    border: `1px solid ${colors.dangerSoft}`,
    background: colors.dangerSoft,
    color: colors.danger,
    cursor: "pointer",
  },
};
